import { render, staticRenderFns } from "./PModal.vue?vue&type=template&id=4527025f&scoped=true&"
import script from "./PModal.vue?vue&type=script&lang=ts&"
export * from "./PModal.vue?vue&type=script&lang=ts&"
import style0 from "./PModal.vue?vue&type=style&index=0&id=4527025f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527025f",
  null
  
)

export default component.exports